import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import MiSelect from '../../componentes/formulario/MiSelect';
import { Alert } from '../../componentes/ui/Alert';
import Uplm from '../../componentes/formulario/Uplm/Uplm';
import UplmPlus from '../../componentes/formulario/UplmPlus/UplmPlus';
import Upls from '../../componentes/formulario/Upls/Upls';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ListaRel from '../../componentes/formulario/ListaRel/ListaRel';
import Informes from '../../componentes/formulario/informes/Informes';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';

function Sfi(props){

    const cookies = new Cookies();

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin } = useLogicForm();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");


    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                      
                    document.title = getTitle(confPantalla.config.trad, confPantalla.sfi.title);                                      
                    if( respuesta == 1 ){
                        saveTieneNivel(true);   
                        saveEstadoFormPrin(confPantalla.sfi.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.sfi.hijo.estadoform);                         
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.sfi.padre.urls);
                                saveFormularioPrin(confPantalla.sfi.padre.modelform);
                                saveFormularioHijo(confPantalla.sfi.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.sfi.padre.urls, confPantalla.sfi.hijo.urls, confPantalla.sfi.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);     
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 
        
    },[confPantalla])
    


 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.sfi.section.titulo } icono={ confPantalla.sfi.section.icono } col={ confPantalla.sfi.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.sfi.section.wiki } >
                                        <Formulario 
                                                    estadoForm= { estadoFormPrin }
                                                    loading=    { loadReg ? true : false }
                                                    btnNew={ confPantalla.sfi.padre.btnform.new }
                                                    btnSave={ confPantalla.sfi.padre.btnform.save }
                                                    btnSaveAndNew={ confPantalla.sfi.padre.btnform.saveandnew }
                                                    btnDelete={ confPantalla.sfi.padre.btnform.delete }
                                                    btnClone={ confPantalla.sfi.padre.btnform.clone }
                                                    handleSubmit = { e => handleSubmitPrin(e, confPantalla.sfi.padre.urls, confPantalla.sfi.padre.modelform, confPantalla.sfi.padre.tabla, confPantalla.sfi.hijo.modelform, confPantalla.sfi.title) } 
                                                    formulario = { formularioPrin } 
                                                    resetForm = { e => resetFormPrin(confPantalla.sfi.padre.modelform, true, confPantalla.sfi.padre.tabla) }  
                                                    handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.sfi.padre.urls, confPantalla.sfi.padre.modelform, confPantalla.sfi.padre.tabla, confPantalla.sfi.title) }
                                        >                                                                                    
                                            <FormRow clases="" >
                                                <FormInput                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.cod }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.cod.id }   
                                                    type=       { confPantalla.sfi.padre.controles.cod.type }  
                                                    name=       { confPantalla.sfi.padre.controles.cod.name }   
                                                    label=      { confPantalla.sfi.padre.controles.cod.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.cod.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.cod.col } 
                                                    required=   { confPantalla.sfi.padre.controles.cod.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.cod.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.cod.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />
                                                {/* <FormInput                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.modif }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.modif.id }   
                                                    type=       { confPantalla.sfi.padre.controles.modif.type }  
                                                    name=       { confPantalla.sfi.padre.controles.modif.name }   
                                                    label=      { confPantalla.sfi.padre.controles.modif.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.modif.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.modif.col } 
                                                    required=   { confPantalla.sfi.padre.controles.modif.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.modif.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.modif.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />                                               */}
                                            </FormRow>
                                            <FormRow clases="" >
                                                <FormInput                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.nom }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.nombre.id }   
                                                    type=       { confPantalla.sfi.padre.controles.nombre.type }  
                                                    name=       { confPantalla.sfi.padre.controles.nombre.name }   
                                                    label=      { confPantalla.sfi.padre.controles.nombre.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.nombre.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.nombre.col } 
                                                    required=   { confPantalla.sfi.padre.controles.nombre.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.nombre.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.nombre.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />
                                                <FormInput                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.nom_en }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.nombre_en.id }   
                                                    type=       { confPantalla.sfi.padre.controles.nombre_en.type }  
                                                    name=       { confPantalla.sfi.padre.controles.nombre_en.name }   
                                                    label=      { confPantalla.sfi.padre.controles.nombre_en.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.nombre_en.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.nombre_en.col } 
                                                    required=   { confPantalla.sfi.padre.controles.nombre_en.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.nombre_en.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.nombre_en.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />                                              
                                            </FormRow>
                                            <FormRow>
                                                <TextArea                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.notas }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.notas.id }   
                                                    name=       { confPantalla.sfi.padre.controles.notas.name }
                                                    rows=       { confPantalla.sfi.padre.controles.notas.rows }      
                                                    label=      { confPantalla.sfi.padre.controles.notas.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.notas.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.notas.col } 
                                                    required=   { confPantalla.sfi.padre.controles.notas.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.notas.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.notas.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />
                                                <TextArea                                                        
                                                    estadoForm= { estadoFormPrin }
                                                    value=      { formularioPrin.notas_en }
                                                    loading=    { loadReg ? true : false }
                                                    id=         { confPantalla.sfi.padre.controles.notas_en.id }   
                                                    name=       { confPantalla.sfi.padre.controles.notas_en.name }
                                                    rows=       { confPantalla.sfi.padre.controles.notas_en.rows }      
                                                    label=      { confPantalla.sfi.padre.controles.notas_en.label }                                                       
                                                    placeholder={ confPantalla.sfi.padre.controles.notas_en.placeholder }    
                                                    col=        { confPantalla.sfi.padre.controles.notas_en.col } 
                                                    required=   { confPantalla.sfi.padre.controles.notas_en.required }
                                                    readonly=   { confPantalla.sfi.padre.controles.notas_en.readonly }                                                
                                                    disabled=   { confPantalla.sfi.padre.controles.notas_en.disabled }
                                                    change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                    onBlur=     {null} 
                                                />
                                            </FormRow>
                                        </Formulario>
                                        <MiDataTable
                                            formulario={formularioPrin} 
                                            estadoForm= { estadoFormPrin }
                                            id={"sfi"}
                                            columnas={confPantalla.sfi.padre.datatable.columns}
                                            data={registrosPrin}
                                            buttons={confPantalla.sfi.padre.datatable.buttons}
                                            ordering={confPantalla.sfi.padre.datatable.ordering}
                                            order={confPantalla.sfi.padre.datatable.order}
                                            searching={confPantalla.sfi.padre.datatable.searching}
                                            paging={confPantalla.sfi.padre.datatable.paging}
                                            select={confPantalla.sfi.padre.datatable.select}
                                            pagelength={confPantalla.sfi.padre.datatable.pagelength}
                                            handleEditReg= { e => handleEditRegPrin(e, confPantalla.sfi.padre.urls, confPantalla.sfi.hijo.urls, confPantalla.sfi.padreshijos, confPantalla.sfi.hijo.modelform, confPantalla.sfi.padre.tabla) }
                                            handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.sfi.padre.urls, confPantalla.sfi.padre.modelform, confPantalla.sfi.padre.tabla, confPantalla.sfi.title) }
                                            saveLoadingTable={ saveLoadingTable }
                                            loadingTable={loadingTable}
                                            columnactions={confPantalla.sfi.padre.datatable.columnactions.title}
                                            traduction={confPantalla.config.trad.components.datatable}
                                        />                                             
                                                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Sfi